"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _toConsumableArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = evaluateExpressions;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _withWebId = _interopRequireDefault(require("./withWebId"));

var _ExpressionEvaluator = _interopRequireDefault(require("../ExpressionEvaluator"));

var _util = require("../util");
/**
 * Higher-order component that evaluates LDflex expressions in properties
 * and passes their results to the wrapped component.
 */


function evaluateExpressions(valueProps, listProps, Component) {
  // Shift the optional listProps parameter when not specified
  if (!Component) {
    var _ref = [listProps, []];
    Component = _ref[0];
    listProps = _ref[1];
  }

  valueProps = valueProps ? _toConsumableArray(valueProps) : [];
  listProps = listProps ? _toConsumableArray(listProps) : []; // Create the initial state for all Component instances

  var initialState = {
    pending: true
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = valueProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;
      initialState[name] = undefined;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = listProps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _name = _step2.value;
      initialState[_name] = [];
    } // Create a higher-order component that wraps the given Component

  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var EvaluateExpressions =
  /*#__PURE__*/
  function (_react$default$Compon) {
    _inherits(EvaluateExpressions, _react$default$Compon);

    function EvaluateExpressions() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, EvaluateExpressions);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EvaluateExpressions)).call.apply(_getPrototypeOf2, [this].concat(args)));
      (0, _defineProperty2.default)(_assertThisInitialized(_this), "state", initialState);
      return _this;
    }

    _createClass(EvaluateExpressions, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.evaluator = new _ExpressionEvaluator.default();

        this.update = function (state) {
          return _this2.setState(state);
        };

        this.evaluate(valueProps, listProps);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this3 = this;

        // A property needs to be re-evaluated if it changed
        // or, if it is a string expression, when the user has changed
        // (which might influence the expression's evaluation).
        var newUser = this.props.webId !== prevProps.webId;

        var changed = function changed(name) {
          return _this3.props[name] !== prevProps[name] || newUser && typeof _this3.props[name] === 'string';
        };

        this.evaluate(valueProps.filter(changed), listProps.filter(changed));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.evaluator.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, this.state));
      }
    }, {
      key: "evaluate",
      value: function evaluate(values, lists) {
        var props = this.props,
            evaluator = this.evaluator;
        if (values.length > 0 || lists.length > 0) evaluator.evaluate((0, _util.pick)(props, values), (0, _util.pick)(props, lists), this.update);
      }
    }]);

    return EvaluateExpressions;
  }(_react.default.Component);

  (0, _defineProperty2.default)(EvaluateExpressions, "displayName", "EvaluateExpressions(".concat((0, _util.getDisplayName)(Component), ")"));
  return (0, _withWebId.default)(EvaluateExpressions);
}